var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo"}},[_c('p',{class:_vm.clazz,staticStyle:{"white-space":"normal !important"},style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.message)}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }